import { useMutation } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useContactGroups } from 'hooks/useContactGroups';
import { postCompany } from '../requests';
import type { Group, PostCompanyRequestType } from '../types';

export const usePostCompany = (
  { pathParams }: { pathParams: PostCompanyRequestType['pathParams'] },
  options?: {
    onSuccess: () => void;
    onError: (error: unknown) => void;
  },
) => {
  const contactGroups = useContactGroups();

  return useMutation({
    mutationKey: [API_QUERY_KEYS.postCompany],
    mutationFn: (bodyParams: PostCompanyRequestType['bodyParams']) =>
      postCompany({
        pathParams,
        bodyParams,
      }),
    onSuccess: async data => {
      if (options?.onSuccess) {
        options.onSuccess();
      }
      const newGroups = (data?.groups as unknown as Group[]) || [];

      contactGroups.add(newGroups.map(g => g.name));
    },
    ...options,
  });
};
